import React, { useEffect, useState } from "react";
import { InputField } from "../../../components/common/InputField";
import UploadedBanner from "../../../components/common/UploadBanner";
import { SinglePlanOverViewInput } from "../../../config/singleWorkout";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const SinglePlanOverView = ({
  jsonData,
  planData,
  selectedPlanId,
  handleImageUrlChange,
  handleVideoUrlChange,
  imageUrl,
  videoUrl,
}) => {
  const [formData, setFormData] = useState({
    workoutName: "",
    workoutKeywords: "",
    goalOrientation: "",
    trainingType: "",
    location: "",
    workoutDuration: "",
    subCategoryCount: 0,
    caloriesBurnedPerMinute: "",
    banner_image: "",
    workout_video: "",
  });

  const { imageUrls: bannerOptions, videoUrls: videoOptions } = useMediaStore();

  useEffect(() => {
    const data = selectedPlanId ? planData : jsonData;
    if (data) {
      setFormData({
        workoutName: data.workoaut_name || "",
        workoutKeywords: data.workout_keywords?.join(", ") || "",
        goalOrientation: data.goal_orientation?.join(", ") || "",
        trainingType: data.training_type || "",
        location: data.location || "",
        workoutDuration: data.estimated_duration || "",
        subCategoryCount: data?.categories?.length || 0,
        caloriesBurnedPerMinute: data.average_calories_burned_per_minute || "",
        banner_image: data.banner_image || imageUrl || "",
        workout_video: data.workout_video || videoUrl || "",
      });
    }
  }, [selectedPlanId, planData, jsonData, imageUrl, videoUrl]);
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "banner_image") {
      handleImageUrlChange(value);
    } else if (key === "workout_video") {
      handleVideoUrlChange(value);
    }
  };

  const handleSelectChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div
      className="tab-pane fade show active"
      id="home-tab-pane"
      role="tabpanel"
      aria-labelledby="home-tab"
      tabIndex="0"
    >
      <div className="row">
        <div className="col-sm-2 mb-3"></div>
        <div className="col-sm-7 mb-3">
          <div className="col-sm-12 mb-3 ">
            <h4>WORKOUT OVERVIEW</h4> <hr className=" border-2 text-bg-info" />
            <div className="col-sm-12 d-flex flex-wrap" id ="sddss">
              {SinglePlanOverViewInput.map((field, index) =>
                field.id === "bannerImageUrl" || field.id === "videoUrl" ? (
                  <div className="mb-3" style={field.id === "videoUrl" ? {width: '33%'} : {}} key={index}>
                  <SearchableSelectField
                    key={index}
                    label={field.id === "bannerImageUrl" ? 'Image Name': 'Video Name'}
                    id={field.id}
                    options={
                      field.id === "bannerImageUrl"
                        ? bannerOptions
                        : videoOptions
                    }
                    value={formData[field.valueKey]}
                    disabled={field.disabled}
                    onChange={(value) =>
                      handleSelectChange(field.valueKey, value)
                    }
                  />
                  </div>
                )  : field.type === "textarea" ? (
                  <div className="mb-3" key={index}>
                    <label htmlFor={field.id} className="form-label">
                      {field.label}
                    </label>
                    <textarea
                      className="form-control"
                      id={field.id}
                      rows={field.rows}
                      value={formData[field.valueKey]}
                      disabled={field.disabled}
                    />
                  </div>
                ) : (
                  <InputField
                    key={index}
                    label={field.label}
                    type={field.type}
                    id={field.id}
                    value={formData[field.valueKey]}
                    onChange={(e) =>
                      handleChange(field.valueKey, e.target.value)
                    }
                    disabled={field.disabled}
                  />
                )
              )}

            

             
            </div>
          </div>
        </div>
        <div className="col-sm-3 mb-3">
          <UploadedBanner defaultImage={formData.banner_image} />
        </div>
      </div>
    </div>
  );
};

export default SinglePlanOverView;
